export function centerSliderByPage(slider, index) {
    slider.go(`>${index}`);
}

export function centerSliderByItem(slider, index) {
    slider.go(index);
}

export function updateSlider(vueComponent, slider) {
    vueComponent.$nextTick(() => {
        slider.refresh();
    });
}
